import { render, staticRenderFns } from "./preportdetail.vue?vue&type=template&id=25f7852d&scoped=true&"
import script from "./preportdetail.vue?vue&type=script&lang=js&"
export * from "./preportdetail.vue?vue&type=script&lang=js&"
import style0 from "./preportdetail.vue?vue&type=style&index=0&id=25f7852d&lang=scss&scoped=true&"
import style1 from "./preportdetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f7852d",
  null
  
)

export default component.exports